
export default (_el, binding) => {
  const el = _el;
  el.onclick = () => {
    const data = {
      screen_name: window.Vue.$route.name,
      button_link: binding.value.buttonLink,
      button_text: binding.value.buttonText,
    };

    switch (binding.value.contentType) {
      case 'podcast':
      case 'podcast-feedback':
      case 'podcast-feedback-submit':
      case 'podcast-share': {
        const podcast = binding.value.contentData;
        if (podcast && podcast.uuid) {
          data.podcast_uuid = podcast.uuid;
          data.podcast_title = podcast.title || '';
        }
        break;
      }
      case 'episode':
      case 'episode-share': {
        const episode = binding.value.contentData;
        if (episode && episode.uuid) {
          const podcast = episode.season && episode.season.podcast ? episode.season.podcast : null;
          data.episode_uuid = episode.uuid;
          data.episode_title = episode.title || '';

          if (podcast && podcast.uuid) {
            data.podcast_uuid = podcast.uuid;
            data.podcast_title = podcast.title || '';
          }
        }
        break;
      }
      default:
        break;
    }
    window.$analytics.track('Button Click', data);
  };
};
